// extracted by mini-css-extract-plugin
export default {"uncap":"Uncap_uncap__Jx3bp"};